<script lang="ts" setup>
import type { ParsedAssignmentAnswer } from '../../models/Assignment'
import { KsButton } from '@aschehoug/kloss'
import { useI18n } from '../../composables/useI18n'
import { useUrlBuilder } from '../../composables/useUrlBuilder'

const { formWriterRoute } = useUrlBuilder()
const { t } = useI18n()

const props = defineProps<{
  assignmentAnswer: ParsedAssignmentAnswer | null
  url: string
  userId: string
}>()
</script>

<template>
  <section class="space-y-6">
    <div
      v-for="(answer, question) in props.assignmentAnswer"
      :key="question"
    >
      <p
        class="mb-1 text-sm font-medium text-gray-40"
        v-text="question"
      />
      <p v-text="answer" />
    </div>
    <KsButton
      variant="secondary"
      size="medium"
      iconRight="arrow-right"
      :href="formWriterRoute(url, userId)"
    >
      {{ t('activity.button.toAssignment') }}
    </KsButton>
  </section>
</template>
